let canvasPrototype = window.CanvasRenderingContext2D && CanvasRenderingContext2D.prototype;
canvasPrototype.dottedLine = function (x1, y1, x2, y2, interval) { if (!interval) { interval = 5; } var isHorizontal = true; if (x1 == x2) { isHorizontal = false; } var len = isHorizontal ? x2 - x1 : y2 - y1; this.moveTo(x1, y1); var progress = 0; while (len > progress) { progress += interval; if (progress > len) { progress = len; } if (isHorizontal) { this.moveTo(x1 + progress, y1); this.arc(x1 + progress, y1, 1, 0, Math.PI * 2, true); this.fill(); } else { this.moveTo(x1, y1 + progress); this.arc(x1, y1 + progress, 1, 0, Math.PI * 2, true); this.fill(); } } }
canvasPrototype.drawDashLine = function (ctx, x1, y1, x2, y2, dashLength) {
  var dashLen = dashLength === undefined ? 5 : dashLength,
    xpos = x2 - x1, //得到横向的宽度;
    ypos = y2 - y1, //得到纵向的高度;
    numDashes = Math.floor(Math.sqrt(xpos * xpos + ypos * ypos) / dashLen);
  //利用正切获取斜边的长度除以虚线长度，得到要分为多少段;
  for (var i = 0; i < numDashes; i++) {
    if (i % 2 === 0) {
      ctx.moveTo(x1 + (xpos / numDashes) * i, y1 + (ypos / numDashes) * i);
      //有了横向宽度和多少段，得出每一段是多长，起点 + 每段长度 * i = 要绘制的起点；
    } else {
      ctx.lineTo(x1 + (xpos / numDashes) * i, y1 + (ypos / numDashes) * i);
    }
  }
  ctx.stroke();
}